import { Snackbar } from "@material-ui/core";

import {
  getAllCategories,
  addNewProduct,
  getAllFamilies,
  getAllSubFamiliesByFamilyId,
  getAllCategoriesBySubFamilyId,
} from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import AddBrand from "../../ui/AddBrand";
// import currentUserId from "./../../currentUserId";
import api from "./../../services/api";

import { useEffect, useState } from "react";
import AddCategory from "../../ui/AddCategory";
import AddFamily from "../../ui/AddFamily";
import ConfirmAddCategory from "../../ui/ConfirmAddCategory";
import { Alert } from "@material-ui/lab";
import ConfirmAddProduct from "../../ui/ConfirmAddProduct";
import AddSubFamily from "../../ui/AddSubFamily";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import SpecificityService from "../../services/SpecificityService";
import { useNavigate } from "react-router-dom";

const AddSpecificityToCategory = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const availableFamilies = useSelector(
    (state) => state.staff.availableFamilies
  );

  const availableSubFamilies = useSelector(
    (state) => state.staff.availableSubFamilies
  );

  const availableCategories = useSelector(
    (state) => state.staff.availableCategories
  );

  const [label, setLabel] = useState("");

  const [familyId, setFamilyId] = useState(0);

  const [subFamilyId, setSubFamilyId] = useState(0);
  const [categoryId, setCategoryId] = useState(0);
  const [categoryName, setCategoryName] = useState("");
  const [subFamilyName, setSubFamilyName] = useState(null);
  const [infoAlertText, setInfoAlertText] = useState();

  const [categoryDesc, setCategoryDesc] = useState("");
  const [confirmSubFamilyModel, setConfirmSubFamilyModel] = useState();
  const [onAddFamily, setOnAddFamily] = useState(false);
  const [onConfirmAddSubFamily, setOnConfirmAddSubFamily] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [confirmProductModel, setConfirmProductModel] = useState();
  const [myProductModel, setMyProductModel] = useState({});
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [isCancel, setIsCancel] = useState(false);
  const [onAddBrand, setOnAddBrand] = useState(false);
  const [onAddCategory, setOnAddCategory] = useState(false);
  const [onAddSubFamily, setOnAddSubFamily] = useState(false);
  const [onConfirmAddProduct, setOnConfirmAddProduct] = useState(false);

  const [typeColor, setTypeColor] = useState(false);

  useEffect(() => {
    dispatch(getAllFamilies(0));
  }, []);

  useEffect(() => {
    if (
      onConfirmAddSubFamily === false &&
      confirmSubFamilyModel != null &&
      isCancel === false
    ) {
      setOpenSuccessAlert(true);
      setSuccessAlertText("Ajouté avec succès");
    }
  }, [onConfirmAddSubFamily]);

  useEffect(() => {
    availableFamilies &&
      availableFamilies.map((element, i) => {
        if (i === 0) {
          setFamilyId(element.id);
        }
      });
  }, [availableFamilies]);

  useEffect(() => {
    familyId && dispatch(getAllSubFamiliesByFamilyId(familyId));
  }, [familyId]);
  useEffect(() => {
    subFamilyId && dispatch(getAllCategoriesBySubFamilyId(subFamilyId));
  }, [subFamilyId]);

  useEffect(() => {
    if (availableSubFamilies.length === 0) {
      setSubFamilyId(0);
    }
    availableSubFamilies &&
      availableSubFamilies.map((element, i) => {
        if (i === 0) {
          setSubFamilyId(element.id);
        }
      });
  }, [availableSubFamilies]);
  useEffect(() => {
    if (availableCategories.length === 0) {
      setCategoryId(0);
    }
    console.log("availableCategories", availableCategories);
    availableCategories &&
      availableCategories.map((element, i) => {
        if (i === 0) {
          setCategoryId(element.id);
        }
      });
  }, [availableCategories]);

  const onChangeLabelHandler = (event) => {
    setLabel(event.target.value);
  };

  // const onChangeSubFamilyNameHandler = (event) => {
  //   setSubFamilyName(event.target.value);
  // };

  // const onChangeDescriptionHandler = (event) => {
  //   setCategoryDesc(event.target.value);
  // };

  // const onAddFamilyHandler = () => {
  //   setOnAddFamily(true);
  // };

  // const onValidCategoryHandler = () => {
  //   if (categoryName === "") {
  //     setErrorAlertText("Erreur :le champ du nom est vide ! ");
  //     setOpenErrorAlert(true);
  //   } else if (familyId === 0) {
  //     setErrorAlertText("Erreur :le champ du famille est vide ! ");
  //     setOpenErrorAlert(true);
  //   } else if (subFamilyId === 0) {
  //     if (subFamilyName == null) {
  //       setErrorAlertText(
  //         "Erreur :le champ du  nom de sous famille est vide ! "
  //       );
  //       setOpenErrorAlert(true);
  //     } else {
  //       let productFamilyName = "";
  //       for (let index = 0; index < availableFamilies.length; index++) {
  //         if (availableFamilies[index].id == familyId)
  //           productFamilyName = availableFamilies[index].name;
  //       }

  //       let confirmSubFamilyModel = {
  //         categoryName: categoryName,
  //         description: categoryDesc,
  //         idProductFamily: familyId,
  //         productFamilyName: productFamilyName,
  //         idUserCreation: 0,
  //         subFamilyName: subFamilyName,
  //         idSubFamily: null,
  //       };
  //       setConfirmSubFamilyModel(confirmSubFamilyModel);
  //       setOnConfirmAddSubFamily(true);
  //       console.log(confirmSubFamilyModel);
  //     }
  //   } else {
  //     let productFamilyName = "";
  //     for (let index = 0; index < availableFamilies.length; index++) {
  //       if (availableFamilies[index].id == familyId) {
  //         productFamilyName = availableFamilies[index].name;
  //         break;
  //       }
  //     }

  //     let productSubFamilyName = "";
  //     for (let index = 0; index < availableSubFamilies.length; index++) {
  //       if (availableSubFamilies[index].id == subFamilyId) {
  //         productSubFamilyName = availableSubFamilies[index].name;
  //         break;
  //       }
  //     }

  //     let confirmSubFamilyModel = {
  //       categoryName: categoryName,
  //       description: categoryDesc,
  //       idProductFamily: familyId,
  //       productFamilyName: productFamilyName,
  //       idUserCreation: 0,
  //       idSubFamily: subFamilyId,
  //       subFamilyName: productSubFamilyName,
  //     };
  //     setConfirmSubFamilyModel(confirmSubFamilyModel);
  //     setOnConfirmAddSubFamily(true);
  //     console.log(confirmSubFamilyModel);
  //     //   let familyName = " ";
  //     //   for (let i = 0; i < availableFamilies.length; i++) {
  //     //     if (availableFamilies[i].id == familyId) {
  //     //       familyName = availableFamilies[i].name;
  //     //     }
  //     //   }
  //     //   let confirmSubFamilyModel = {
  //     //     categoryName: categoryName,
  //     //     categoryDesc: categoryDesc,
  //     //     familyName: familyName,
  //     //     familyId : familyId
  //     //   };
  //     //   setConfirmSubFamilyModel(confirmSubFamilyModel);
  //   }
  // };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const handleTypeColor = () => {
    setTypeColor(!typeColor);
  };

  const onConfirmAddSpecificityHandler = () => {
    let typeColorToBackend = 0;
    if (typeColor) {
      typeColorToBackend = 1;
    }
    console.log("couleur", typeColor);
    if (label === "") {
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
      setOpenErrorAlert(true);
    } else if (categoryName == null && categoryId === 0) {
      setErrorAlertText(
        "Erreur :le champ du catégorie  est vide  famille est vide ! "
      );
      setOpenErrorAlert(true);
    } else {
      let productSpecificityModel = {
        idCatégorie: categoryId,
        name: label,
        idUserCreation: getCurrentUserId(),
        type: typeColorToBackend,
      };
      console.log("productSpecificityModel", productSpecificityModel);

      SpecificityService.addProductSpecificity(productSpecificityModel).then(
        (response) => {
          console.log("response", response);
          if (response.status === 200) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/specificities`);
            }, 2000);
          }
        }
      );
    }
  };
  const Checkbox = ({ label, value, onChange }) => {
    return (
      <label>
        <input type="checkbox" checked={value} onChange={onChange} />
        {label}
      </label>
    );
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Spécificité</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">Ajouter un spécificité</h5>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div class="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="label">Libellé</label>
                        <input
                          onChange={onChangeLabelHandler}
                          type="text"
                          id="label"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div className="form-group">
                        <label>Choisir la famille</label>
                        <select
                          value={familyId || null}
                          onChange={(e) => {
                            setFamilyId(e.target.value);
                            setSubFamilyName(null);
                          }}
                          className="form-control select2"
                          style={{ width: "100%" }}
                        >
                          {availableFamilies &&
                            availableFamilies.map((element, index) =>
                              index === 0 ? (
                                <option
                                  key={element.id}
                                  value={element.id}
                                  selected="selected"
                                >
                                  {element.name}
                                </option>
                              ) : (
                                <option key={element.id} value={element.id}>
                                  {element.name}
                                </option>
                              )
                            )}
                        </select>
                      </div>
                    </div>

                    {subFamilyId !== 0 ? (
                      <div class="col-sm-3">
                        <div className="form-group">
                          <label>Choisir la sous famille</label>
                          <select
                            value={subFamilyId || null}
                            onChange={(e) => setSubFamilyId(e.target.value)}
                            className="form-control select2"
                            style={{ width: "100%" }}
                          >
                            {availableSubFamilies &&
                              availableSubFamilies.map((element, index) =>
                                index === 0 ? (
                                  <option
                                    key={element.id}
                                    value={element.id}
                                    selected="selected"
                                  >
                                    {element.name}
                                  </option>
                                ) : (
                                  <option key={element.id} value={element.id}>
                                    {element.name}
                                  </option>
                                )
                              )}
                          </select>
                        </div>
                      </div>
                    ) : (
                      <div class="col-sm-3"></div>
                    )}
                    {/* catégorie */}
                    {categoryId !== 0 ? (
                      <div class="col-sm-3">
                        <div className="form-group">
                          <label>Choisir la sous catégorie</label>
                          <select
                            value={categoryId || null}
                            onChange={(e) => setCategoryId(e.target.value)}
                            className="form-control select2"
                            style={{ width: "100%" }}
                          >
                            {availableCategories &&
                              availableCategories.map((element, index) =>
                                index === 0 ? (
                                  <option
                                    key={element.id}
                                    value={element.id}
                                    selected="selected"
                                  >
                                    {element.name}
                                  </option>
                                ) : (
                                  <option key={element.id} value={element.id}>
                                    {element.name}
                                  </option>
                                )
                              )}
                          </select>
                        </div>
                      </div>
                    ) : (
                      <div class="col-sm-3"></div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <Checkbox
                          // label=" Spécificité de couleur"
                          value={typeColor}
                          onChange={handleTypeColor}
                          style={{ color: "black" }}
                        />
                        <label class="form-check-label" for="inlineRadio1">
                          Spécificité de couleur
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-dark float-right"
                    onClick={onConfirmAddSpecificityHandler}
                  >
                    Ajouter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="content ">
      <div className="form-group" class="col-sm-2" style={{ marginTop: 32 }}>
        <a
          href="#"
          class="btn btn-success float-right"
          onClick={onConfirmAddProductHandler}
        >
          Ajouter
        </a>{" "}
      </div>
    </div> */}
      <div class="col-sm-10"> </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      {onAddSubFamily && (
        <AddSubFamily
          familyId={familyId}
          setOnAddSubFamily={setOnAddSubFamily}
        />
      )}
      {onAddFamily && <AddFamily setOnAddFamily={setOnAddFamily} />}
      {onAddBrand && <AddBrand setOnAddBrand={setOnAddBrand} />}
      {onAddCategory && (
        <AddCategory
          familyId={familyId}
          subFamilyId={subFamilyId}
          setOnAddCategory={setOnAddCategory}
        />
      )}
      {onConfirmAddProduct && (
        <ConfirmAddProduct
          setOnConfirmAddProduct={setOnConfirmAddProduct}
          confirmProductModel={confirmProductModel}
          setMyProductModel={setMyProductModel}
        />
      )}
    </div>
  );
};
export default AddSpecificityToCategory;
